// Radio playlist — track ids point at files under /public/music/.
// The Radio shuffles through all entries. Tracks are added by:
//   1. Dropping a track-N.ogg into public/music/
//   2. Adding the slot here

export interface PlaylistTrack {
  id: string;
  url: string;
  /** Human-readable song title shown by the now-playing toast. */
  title?: string;
}

export const PLAYLIST: PlaylistTrack[] = [
  { id: 'track-1',  url: 'music/track-1.ogg',  title: 'cascade'             },
  { id: 'track-2',  url: 'music/track-2.ogg',  title: 'stack & drift'       },
  { id: 'track-3',  url: 'music/track-3.ogg',  title: 'patience'            },
  { id: 'track-4',  url: 'music/track-4.ogg',  title: 'held for later'      },
  { id: 'track-5',  url: 'music/track-5.ogg',  title: 'perfectly clear'     },
  { id: 'track-6',  url: 'music/track-6.ogg',  title: 'fading out'          },
  { id: 'track-7',  url: 'music/track-7.ogg',  title: 'ghosts'              },
  { id: 'track-8',  url: 'music/track-8.ogg',  title: 'laws of attraction'  },
  { id: 'track-9',  url: 'music/track-9.ogg',  title: 'the well'            },
  { id: 'track-10', url: 'music/track-10.ogg', title: 'holding pattern'     },
  { id: 'track-11', url: 'music/track-11.ogg', title: 'focusing'            },
  { id: 'track-12', url: 'music/track-12.ogg', title: 'one at a time'       },
  { id: 'track-13', url: 'music/track-13.ogg', title: 'bag of seven'        },
  { id: 'track-14', url: 'music/track-14.ogg', title: 'foreverfall'         },
  { id: 'track-15', url: 'music/track-15.ogg', title: 'deepen'              },
  { id: 'track-16', url: 'music/track-16.ogg', title: 'piece of the puzzle' },
  { id: 'track-17', url: 'music/track-17.ogg', title: 'reflection'          },
  { id: 'track-18', url: 'music/track-18.ogg', title: 'lost in thought'     },
  { id: 'track-19', url: 'music/track-19.ogg', title: 'crumbling'           },
  { id: 'track-20', url: 'music/track-20.ogg', title: 'tangram'             },
  { id: 'track-21', url: 'music/track-21.ogg', title: 'foundations'         },
  { id: 'track-22', url: 'music/track-22.ogg', title: 'connected'           },
  { id: 'track-23', url: 'music/track-23.ogg', title: 'brick by brick'      },
];
